import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const chatState = (state: RootState) => state.chat;

export const getChatGeometry = createSelector(chatState, ({ geometry }) => geometry);

export const isChatHideRequested = createSelector(
  chatState,
  ({ hideRequestCount }) => hideRequestCount > 0
);

export const isChatMaximized = createSelector(
  chatState,
  ({ geometry }) => geometry.restore !== undefined
);

export const isChatOpen = createSelector(chatState, ({ isOpen }) => isOpen);

// The whole object, for the persistence saga, which writes preferences as a unit.
export const getChatPreferences = createSelector(chatState, ({ preferences }) => preferences);

export const isChatReadResponsesAloudEnabled = createSelector(
  chatState,
  ({ preferences }) => preferences.readResponsesAloud
);

export const isChatSettingsOpen = createSelector(chatState, ({ isSettingsOpen }) => isSettingsOpen);

export const isChatVoiceInputEnabled = createSelector(
  chatState,
  ({ preferences }) => preferences.voiceInputEnabled
);
